import { makeRequest } from '@breezeventures/web-lib-ph-request/make-request';
import { ResponseSuccess } from '@breezeventures/web-lib-ph-request/types';
import { AddressSuggestionParams } from '@breezeventures/web-ph-address-suggestions/api';
import { Address } from '@breezeventures/web-ph-address-suggestions/model';

export function getAddressSuggestions({
  apiHost,
  ...params
}: AddressSuggestionParams & { apiHost: string }) {
  return makeRequest<ResponseSuccess<Address[]>>({
    url: `${apiHost}/geocoder/api/v1/suggest-address`,
    credentials: 'include',
    payload: params,
  }).then((response) => response.payload);
}
